<!-- Menu - Desk -->
<div class="menu_desk">
  <div class="menu_container">
    <div class="menu_mymenu" *ngIf="!isAdmin; else admin">
      <div class="menu_list">
        <!-- Title -->
        <div class="menu_list_title">
          <label>Supplier Menu</label>
        </div>

        <!-- HOME -->
        <!-- <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <div class="menu_list_mark"></div>
          <a [routerLink]="['/home']">
            <mat-icon class="menu_list_icon" aria-label="Home">home</mat-icon>
            <span>Home (Dashboard)</span>
          </a>
          <div class="separator"></div>
        </div> -->

        <!-- New Inspections -->
        <!-- <div class="menu_list_element sub" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <div class="menu_list_mark"></div>
          <div class="menu_list_link">
            <a [routerLink]="['/home/inspection/news']">
              <mat-icon class="menu_list_icon" aria-label="New Inspections">zoom_in</mat-icon>
              <span>New Inspections</span>
            </a>
            <mat-icon class="sub_icon" [ngClass]="isOpenNewInspections ? 'open' : 'closed'"
              (click)="openNewInspections();">keyboard_arrow_down</mat-icon>
          </div>
          <div class="separator"></div>
        </div> -->

        <!-- New Inspections / Detail -->
        <!-- <div class="submenu" [@toggleBox]="isOpenNewInspections ? 'open' : 'closed'">
          <div class="menu_list_element" routerLinkActive="active">
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/home/inspection/new_inspection/']">
              <mat-icon class="menu_list_icon" aria-label="Detail">reorder</mat-icon>
              <span>Detail</span>
            </a>
            <div class="separator"></div>
          </div>
        </div> -->

        <!-- Certification Inspections -->
        <!-- <div class="menu_list_element sub">
          <div class="menu_list_mark"></div>
          <a (click)="openSub();">
            <mat-icon class="menu_list_icon" aria-label="CertificationInspections">search</mat-icon>
            <span>Certification Inspections</span>
            <mat-icon class="sub_icon" [ngClass]="isOpen ? 'open' : 'closed'">keyboard_arrow_down</mat-icon>
          </a>
          <div class="separator"></div>
        </div> -->

        <!-- Certification Inspections / Data Registration -->
        <!-- <div class="submenu" [@toggleBox]="isOpen ? 'open' : 'closed'">
          <div class="menu_list_element" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/home/inspection/data_registrationB']">
              <mat-icon class="menu_list_icon" aria-label="DataRegistrationB">edit_note</mat-icon>
              <span>Data Registration</span>
            </a>
            <div class="separator"></div>
          </div>
        </div> -->
      </div>
    </div>
    <ng-template #admin>
      <div class="menu_admin">
        <div class="menu_list">
          <div class="menu_list_title">
            <label>Admin Menu</label>
          </div>
          <div
            class="menu_list_element"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/admin']">
              <mat-icon class="menu_list_icon" aria-label="Home">home</mat-icon>
              <span>Home</span>
            </a>
            <div class="separator"></div>
          </div>
          <div
            class="menu_list_element"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/home/inspection/plans']">
              <mat-icon class="menu_list_icon" aria-label="DataRegistrationB"
                >list_alt</mat-icon
              >
              <span>Inspection Plans</span>
            </a>
            <div class="separator"></div>
          </div>
          <div
            class="menu_list_element"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="goToInspectionScheduller()"
          >
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/admin/scheduler']">
              <mat-icon class="menu_list_icon" aria-label="DataRegistrationB"
                >edit_notifications</mat-icon
              >
              <span>Inspection Scheduler</span>
            </a>
            <div class="separator"></div>
          </div>

          <div
            class="menu_list_element"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="menu_list_mark"></div>
            <a [routerLink]="['/admin/users']">
              <mat-icon class="menu_list_icon" aria-label="DataRegistrationB"
                >people</mat-icon
              >
              <span>Users</span>
            </a>
            <div class="separator"></div>
          </div>

          <div class="menu_list_element sub">
            <div class="menu_list_mark"></div>
            <a (click)="openOtherAdmin()">
              <mat-icon
                class="menu_list_icon"
                aria-label="CertificationInspections"
                >admin_panel_settings</mat-icon
              >
              <span>Admin Section</span>
              <mat-icon
                class="sub_icon"
                [ngClass]="isOtherOpenAdmin ? 'open' : 'closed'"
                >keyboard_arrow_down</mat-icon
              >
            </a>
            <div class="separator"></div>
          </div>

          <div
            class="submenu"
            [@toggleBox]="isOtherOpenAdmin ? 'open' : 'closed'"
          >
            <div
              class="menu_list_element"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="menu_list_mark"></div>
              <a [routerLink]="['/home/supplier_list']">
                <mat-icon class="menu_list_icon" aria-label="InspectionDetail"
                  >people</mat-icon
                >
                <span>{{ "button-supplier-list" | translate }}</span>
              </a>
              <div class="separator"></div>
            </div>
          </div>

          <div
            class="submenu"
            [@toggleBox]="isOtherOpenAdmin ? 'open' : 'closed'"
          >
            <div
              class="menu_list_element"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="menu_list_mark"></div>
              <a [routerLink]="['/home/dashboard']">
                <mat-icon class="menu_list_icon" aria-label="InspectionDetail"
                  >insert_chart</mat-icon
                >
                <span>Dashboard Metrics</span>
              </a>
              <div class="separator"></div>
            </div>
          </div>

          <div class="menu_list_element sub">
            <div class="menu_list_mark"></div>
            <a (click)="openSubAdmin()">
              <mat-icon
                class="menu_list_icon"
                aria-label="CertificationInspections"
                >preview</mat-icon
              >
              <span>Review Inspections</span>
              <mat-icon
                class="sub_icon"
                [ngClass]="isOpenAdmin ? 'open' : 'closed'"
                >keyboard_arrow_down</mat-icon
              >
            </a>
            <div class="separator"></div>
          </div>
          <div class="submenu" [@toggleBox]="isOpenAdmin ? 'open' : 'closed'">
            <div
              class="menu_list_element"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="menu_list_mark"></div>
              <a>
                <mat-icon class="menu_list_icon" aria-label="InspectionDetail"
                  >info</mat-icon
                >
                <span>Inspection Detail</span>
              </a>
              <div class="separator"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
